/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { ReactElement, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import posthog from 'posthog-js';
import { setConfigValue } from 'src/store/actions/config.action';
import { Loader } from 'src/components';
import { ApiCalls } from 'src/constants/endpoints.constant';
import { sendEventToParent } from 'src/utils/global';
import { EventType } from 'src/constants/roles.constant';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Messages } from 'src/constants/message.constant';
import { PostHogRegisterCode, PostHogRegisterUrl, PostHogEnabled } from 'src/utils/config';


interface ConfigHocProps {
  children?: ReactElement,
  setConfigValue?: any,
  init?: any,
};

const ConfigHoc = ({
  children,
  setConfigValue,
  init,
} : ConfigHocProps) => {
  const { error } = Modal;
  const [isInitialized, setIsInitialized] = useState(false);
  const [comunicationData, setComunicationData] = useState<any>();

  useEffect(() => {
    const handleMessage = (event:any) => {
      const data = event.data;
      if (data && data?.accessToken)
      {
        setComunicationData(data);
      }
    };

    const sessionIntervalUpdate = setInterval(() => {
      console.log("IAM POLLER_INTERVAL_TIME: Actualizando info de tokens");
      sendEventToParent(EventType.expiredAuth);
    }, ApiCalls.POLLER_INTERVAL_TIME);

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
      clearInterval(sessionIntervalUpdate);
    };
  }, []);

  useEffect(() => {
    if (comunicationData && Object.keys(comunicationData).length > 0) {
      handleInitializeGlobalData();
    }
  }, [comunicationData]);

  useEffect(() => {
    if (init?.error) {
      showConfirmError(init.error);
    }
  }, [init]);

  const handleInitializeGlobalData = () => {
    if (comunicationData) {
      for (const [key, value] of Object.entries(comunicationData)) {
        let payload = {
          field: key,
          value,
        }
        setConfigValue(payload);
        if (key === 'serviceId') {
          setConfigValue({
            field: 'isExternal',
            value: true,
          });
        }
      }
      if (!isInitialized) {
        let isPosthogEnabled = Boolean(PostHogEnabled) ? PostHogEnabled.toLowerCase() === 'true' ? true : false : false;
        if (isPosthogEnabled || comunicationData.analyticsEnabled) {
          posthog.init(PostHogRegisterCode, {
            api_host: PostHogRegisterUrl,
            defaults: '2025-05-24',
            loaded: function (posthog) {
              if (comunicationData.identityId) {
                posthog.identify(comunicationData.identityId);
              };
            },
            on_request_error: function (res) {
              console.error("Posthog Warn", res);
            }
          });
        } else {
          console.log("Posthog Disabled");
        }
        setIsInitialized(true);
      }
    }
  };

  const showConfirmError = (errorMessage:any) => {
    error({
      centered: true,
      keyboard: false,
      icon: <ExclamationCircleOutlined style={{color: "var(--secondary-color)"}} />,
      content: errorMessage,
      okText: Messages.ERROR_CONFIRM_OK,
      onOk() {
        destroyAll();
        sendEventToParent(EventType.servicesNotAvailable);
      },
    });
  };

  const destroyAll = () => {
    Modal.destroyAll();
  };

  return (
    <>
      {!init.error && (
        <>
          {!isInitialized ? (
            <div className="ci-form__loader ci-form__loader--fullpage">
              <Loader fullPage text="Cargando" />
            </div>
          ) : (
            <>
              {children}
            </>
          )}
        </>
      )}
    </>
  );
}

const mapStateToProps = (state:any) => ({
  init: state.init,
});

const mapDispatchToProps = {
  setConfigValue,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigHoc);
